var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Answer_tick_Copy_3",
    "data-name": "Answer tick Copy 3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M10.633.367a1.251,1.251,0,0,0-1.77,0L5.5,3.73,2.137.367a1.252,1.252,0,0,0-1.77,1.77L3.73,5.5.367,8.863a1.252,1.252,0,1,0,1.77,1.77L5.5,7.27l3.363,3.363a1.252,1.252,0,1,0,1.77-1.77L7.27,5.5l3.363-3.363A1.251,1.251,0,0,0,10.633.367Z",
    transform: "translate(8 8)",
    fill: "#da4259"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_2",
    "data-name": "Fill 2",
    d: "M13.5,27A13.5,13.5,0,0,1,8.333,1.028,13.5,13.5,0,0,1,18.667,25.972,13.431,13.431,0,0,1,13.5,27Zm0-24.8A11.3,11.3,0,0,0,5.511,21.489,11.3,11.3,0,1,0,21.489,5.51,11.228,11.228,0,0,0,13.5,2.2Z",
    fill: "#da4259"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedClose);
export default __webpack_public_path__ + "static/media/red-close.5c1fb4353ace902a92277e92fd378272.svg";
export { ForwardRef as ReactComponent };